export default "__VITE_ASSET__5c8f490b__"